import React, { useState } from "react";
import { useAuth } from "../../contexts/AuthContext";
import {
  useMealsSelection,
  usePlan,
  useStep,
} from "../../contexts/SubscriptionContext";
import { motion } from "framer-motion";
import Icon from "../../common/Icon";
import GeneralButton from "../../common/GeneralButton";
import { TiChevronLeft, TiChevronRight } from "react-icons/ti";
import breakfast from "../../../assets/images/breakfast.png";
import lunch from "../../../assets/images/lunch.png";
import snack from "../../../assets/images/snack.png";
import dinner from "../../../assets/images/dinner.png";
import mealShadow from "../../../assets/images/mealShadow.png";
import Modal from "../../common/Modal";
import { useNavigate } from "react-router-dom";
const UpgradeMealSelection = ({ meal }) => {
  const navigate = useNavigate();
  const { selectedMeals, addMeal, removeMeal } = useMealsSelection();
  const isSelected = (mealId) =>
    meal.meals.some((m) => m === mealId.toLowerCase());
  const [screen, setScreen] = useState({
    show: false,
    title: "",
    message: "",
  });

  const meals = [
    {
      id: 1,
      title: "Breakfast",
      price: 20,
      priceBadgeText: "AED 20/meal",
    },
    {
      id: 2,
      title: "Lunch",
      price: 30,
      priceBadgeText: "AED 30/meal",
    },
    {
      id: 3,
      title: "Snack",
      price: 10,
      priceBadgeText: "AED 10/meal",
      description:
        "<p>Snacks can only be added as part of a breakfast, lunch, or combined meal, and are not available separately</p>",
    },
    {
      id: 4,
      title: "Dinner",
      price: 30,
      priceBadgeText: "AED 30/meal",
    },
  ];
  return (
    <motion.div
      initial={{ x: -200, opacity: 0 }}
      animate={{ x: 0, opacity: 1 }}
      exit={{ x: -200, opacity: 0 }}
      transition={{ duration: 0.5, ease: "easeOut" }}
      className=""
    >
      <div className="relative">
        <div className="grid grid-cols-1">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between ">
            <p className="text-34pt pb-0 md:pb-9">Upgrade your meals</p>
          </div>
        </div>

        <div className="relative grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2.5xl:grid-cols-[1.4fr_1.4fr_1.4fr_1.4fr_0.8fr] gap-8 md:gap-10 lg:gap-8 items-start">
          {meals.map((item, index) => {
            const selected = isSelected(item.title);

            // Opacity sequence: 20%, 40%, 60%, 40%
            const opacitySteps = [0.2, 0.4, 0.6, 0.4];
            const opacity = opacitySteps[index % opacitySteps.length];

            const handleClick = () => {
              if (item.title.toLowerCase() === "snack") {
                // Check if any other meal is selected
                const otherMealsSelected = meal?.meals.some(
                  (m) => m.toLowerCase() !== "snack"
                );
                if (!otherMealsSelected) {
                  setScreen((prev) => ({
                    ...prev,
                    show: true,
                    title: "Add Snack to Plan",
                    message:
                      "To add a snack, you need to include at least one other meal in your plan first.",
                  }));
                  return;
                }
              }

              if (selected) {
                // Remove the meal
                setScreen((prev) => ({
                  ...prev,
                  show: true,
                  title: "Selected Meals Cannot Remove",
                  message:
                    "You can only add more meals, but cannot remove existing meals.",
                }));

                // // After removing, check if Snack is now invalid
                // const mainMealsLeft = selectedMeals.filter(
                //   (m) => m.id !== meal.id && m.title !== "Snack"
                // );

                // if (mainMealsLeft.length === 0) {
                //   // Remove Snack if it's alone
                //   const snack = selectedMeals.find((m) => m.title === "Snack");
                //   if (snack) removeMeal(snack.id);
                // }
              } else {
                addMeal(item);
              }
            };

            return (
              <div
                key={index}
                title="Click to select meal"
                className={`cursor-pointer rounded-[15px] flex flex-col items-end ${
                  (index + 1 - 1) % 4 === 0 && index !== 0 ? "col-start-1" : ""
                }`}
                onClick={handleClick}
              >
                <div
                  className={`cursor-pointer w-full rounded-[15px]`}
                  style={{
                    transition:
                      "background-color 0.3s ease, margin 0.3s ease, transform 0.2s ease, box-shadow 0.2s ease",
                  }}
                >
                  <div
                    className={`rounded-[15px] px-8 2.5xl:px-12 pt-8 2.5xl:pt-10 pb-8 relative lg:mb-5 hover:shadow-lg hover:scale-105 transform`}
                    style={{
                      backgroundColor: `rgba(41, 91, 36, ${opacity})`,
                      transition:
                        "background-color 0.3s ease, margin 0.3s ease, transform 0.2s ease, box-shadow 0.2s ease",
                    }}
                  >
                    <h2 className="text-40pt lg:text-48pt leading-none">
                      {item.title}
                    </h2>
                    <h2 className="text-28pt lg:text-32pt leading-none">
                      meal
                    </h2>
                    <div className="relative md:w-[250px] md:h-[250px] flex items-center justify-center">
                      {/* Tray icon */}
                      <Icon icon="mealTray" className="w-full h-full" />

                      <img
                        src={mealShadow}
                        alt="shadow"
                        className="w-full md:w-[260px] h-auto -ms-[50px] mt-1  absolute -z-[1]"
                      />

                      {/* Meal image inside tray */}
                      {item.title.toLowerCase() === "breakfast" && (
                        <img
                          src={breakfast}
                          alt="Breakfast"
                          className="w-[80%] md:w-[220px] h-auto absolute"
                        />
                      )}
                      {item.title.toLowerCase() === "lunch" && (
                        <img
                          src={lunch}
                          alt="Breakfast"
                          className="w-[80%] md:w-[220px] h-auto absolute"
                        />
                      )}
                      {item.title.toLowerCase() === "snack" && (
                        <img
                          src={snack}
                          alt="Snack"
                          className="w-[80%] md:w-[220px] h-auto absolute"
                        />
                      )}
                      {item.title.toLowerCase() === "dinner" && (
                        <img
                          src={dinner}
                          alt="Dinner"
                          className="w-[80%] md:w-[220px] h-auto absolute"
                        />
                      )}

                      {/* Price badge button */}
                      <GeneralButton
                        text={item.priceBadgeText}
                        className="xl:text-18pt lg:text-14pt md:text-18pt text-18pt absolute bottom-0 left-1/2 -translate-x-1/2"
                        textColor="#fff"
                      />
                    </div>

                    <Icon
                      icon={selected ? "checked" : "checkbox"}
                      className={
                        selected
                          ? " w-[41.7px] h-[36px] xs:w-[51.7px] xs:h-[46px] absolute bottom-8 right-[23.5px]"
                          : " w-[30px] h-[30px] xs:w-[42px] xs:h-[42px] absolute bottom-8 right-8"
                      }
                    />
                  </div>
                  <div className={`rounded-[15px] px-2 py-2 `}>
                    <p
                      className="text-18pt md:text-21pt font-mono w-[95%] md:w-[90%] mx-auto"
                      dangerouslySetInnerHTML={{ __html: item.description }}
                    ></p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
        <div className=" mt-5 lg:mt-0 xl:absolute bottom-24 left-0 gap-5 xs:gap-8 grid xs:grid-cols-4 md:grid-cols-4 sm:mt-4 xl:grid-cols-4 2.5xl:grid-cols-[1.4fr_1.4fr_1.4fr_1.4fr_0.8fr] w-full">
          <div className="flex  items-center justify-center xs:justify-start">
            <GeneralButton
              text={"Prev step"}
              onClick={() => navigate(-1)}
              iconPosition="Left"
              bgColor="#ccc"
              textColor="#000"
              icon={<TiChevronLeft size={24} className="ms-0 md:me-4" />}
              className="text-21pt md:text-24pt"
            />
          </div>
          <div className="hidden xs:block"></div>
          <div className="hidden xs:block"></div>
          <div className="flex  items-center justify-center xs:justify-end">
            <GeneralButton
              onClick={()=> navigate("/checkout")}
              text={"Next step"}
              bgColor="#30160E"
              textColor="#ccc"
              icon={<TiChevronRight size={24} className="ms-0 md:ms-4" />}
              className="text-21pt md:text-24pt"
            />
          </div>
        </div>
      </div>
      <Modal
        isOpen={screen.show}
        onClose={() =>
          setScreen((prev) => ({
            ...prev,
            show: false,
          }))
        }
        title={screen.title}
        onConfirm={() =>
          setScreen((prev) => ({
            ...prev,
            show: false,
          }))
        }
        confirmButton="Ok"
        dismissible={false}
        showCancel={false}
      >
        <div className="font-mono">
          <p>{screen.message}</p>
        </div>
      </Modal>
    </motion.div>
  );
};

export default UpgradeMealSelection;
